import * as undoActions from 'owa-mail-undo';
import datapoints from '../datapoints';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import mailStore from 'owa-mail-store/lib/store/Store';
import Message from 'owa-service/lib/contract/Message';
import setItemsInferenceClassificationService from 'owa-mail-triage-action/lib/services/setItemsInferenceClassificationService';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { isItemOfMessageType } from 'owa-mail-list-store';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { handleServerResponseSuccessAndError } from 'owa-mail-triage-action-response-processor';

/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param toViewFilter the focused view filter to move items to
 * @param actionSource the source that initiated this action
 * @return the action response
 */
export default createLegacyActionWithDatapoint(
    'moveItemsToFocusedOrOther',
    datapoints.moveItemToFocusedOrOther
)(function moveItemsToFocusedOrOther(
    itemRowKeys: string[],
    tableViewId: string,
    toViewFilter: FocusedViewFilter,
    actionSource: ActionSource
): Promise<void> {
    const tableView: TableView = listViewStore.tableViews.get(tableViewId);
    const isFocusedView: boolean = toViewFilter == FocusedViewFilter.Focused;
    const itemIdStrings = getRowIdsFromRowKeys(itemRowKeys, tableViewId);

    undoActions.clearLastUndoableAction();

    const itemContexts = itemIdStrings.map(itemIdValue => {
        const item = mailStore.items.get(itemIdValue);
        let isReadValue;

        if (isItemOfMessageType(item)) {
            isReadValue = (item as Message).IsRead;
        } else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }

        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
            mailboxInfo: item.MailboxInfo,
        };
    });

    const setInferenceClassificationPromise = setItemsInferenceClassificationService(
        itemIdStrings,
        isFocusedView ? 'Focused' : 'Other'
    );

    // Dispatch action to update the store state
    deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);

    returnTopExecutingActionDatapoint().markUserPerceivedTime();

    return setInferenceClassificationPromise.then(response => {
        return handleServerResponseSuccessAndError(response);
    });
});
